// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Containertransporttaioncompany() {



const cardData = {


    keyword: "Container Transportation Company in Pune",

    headingDescription: "SSK Logistic is a container transportation company in Pune providing organized road transportation support for businesses that need to move containerized goods, commercial consignments, industrial materials, freight, and distribution cargo across local, regional, and interstate routes. Container transportation requires suitable vehicle planning, coordinated pickup and delivery schedules, route management, loading arrangements, and careful handling of goods throughout transit. SSK Logistic supports manufacturers, distributors, exporters, suppliers, warehouses, commercial businesses, and industrial operations with practical container transportation solutions tailored to shipment requirements. From closed container and closed body transportation to full truck load container movement and industrial freight, the service approach is designed to maintain structured cargo movement between business locations, warehouses, distribution centers, and destination markets.",

    topPlaces: [
        {
            title: "Daund",
            description: "Daund is an important transportation-linked location in the Pune region where businesses may require regular movement of containerized commercial and industrial goods. SSK Logistic supports container transportation from Daund to warehouses, manufacturing facilities, distribution points, and destination markets."
        },
        {
            title: "Pune to Jaipur",
            description: "Pune to Jaipur is a useful interstate route for businesses moving containerized goods toward Rajasthan and surrounding commercial markets. SSK Logistic assists with planned road transportation for commercial products, industrial materials, distribution cargo, and full-load container requirements."
        },
        {
            title: "Kurkumbh",
            description: "Kurkumbh is connected with industrial activity where containerized movement may be required for materials, production goods, equipment, and commercial consignments. SSK Logistic provides transportation coordination between Kurkumbh-based operations, warehouses, suppliers, and destination facilities."
        },
        {
            title: "Pune to Guwahati",
            description: "Pune to Guwahati connects western India's commercial network with northeastern markets over a long-distance transportation corridor. SSK Logistic supports businesses requiring organized container movement for industrial and commercial cargo along this extended interstate route."
        },
        {
            title: "Sanaswadi",
            description: "Sanaswadi lies along Pune's eastern commercial and industrial transportation belt and can generate regular requirements for containerized goods movement. SSK Logistic coordinates transportation between business facilities, warehouses, suppliers, and regional distribution destinations."
        },
        {
            title: "Pune to Faridabad",
            description: "Pune to Faridabad provides connectivity between Pune-based businesses and the wider NCR industrial and commercial network. SSK Logistic assists with container transportation for commercial goods, industrial materials, inventory, and distribution consignments requiring long-distance road movement."
        },
        {
            title: "Katraj",
            description: "Katraj provides access to major Pune road connections and surrounding business areas, making it relevant for local and regional container movement. SSK Logistic supports businesses with planned transportation between commercial locations, warehouses, suppliers, and interstate destinations."
        },
        {
            title: "Pune to Hosur",
            description: "Pune to Hosur connects Maharashtra with an important southern industrial and commercial region. SSK Logistic provides road transportation support for containerized goods, industrial materials, commercial cargo, and recurring freight requirements moving between these locations."
        },
        {
            title: "Narhe",
            description: "Narhe is part of Pune's expanding business network where companies may require transportation of inventory, materials, products, and containerized consignments. SSK Logistic assists with local, regional, and interstate container transportation according to business schedules and destination requirements."
        },
        {
            title: "Pune to Bhilai",
            description: "Pune to Bhilai is a long-distance commercial route connecting western India with an important central Indian industrial market. SSK Logistic supports businesses with planned container transportation for industrial cargo, commercial consignments, and full-load freight requirements."
        }
    ],

    "services": [
        {
            "name": "container transportation company pune",
            "description": "Businesses searching for a container transportation company pune can use SSK Logistic for organized road movement of containerized commercial and industrial cargo. Transportation support includes route coordination, vehicle planning, pickup scheduling, and destination delivery according to shipment requirements."
        },
        {
            "name": "container transport company pune",
            "description": "SSK Logistic supports businesses looking for a container transport company pune with planned movement between suppliers, factories, warehouses, distribution centers, and destination markets. Services can be arranged for local, regional, and interstate containerized freight requirements."
        },
        {
            "name": "container transportation services pune",
            "description": "Container transportation services pune help businesses move goods in suitable containers between different operational and commercial locations. SSK Logistic coordinates road transportation according to cargo type, container requirements, route distance, vehicle capacity, and delivery schedule."
        },
        {
            "name": "container transport services pune",
            "description": "Container transport services pune provide businesses with structured transportation for containerized shipments across Pune, Maharashtra, and other states. SSK Logistic assists with pickup, route planning, transportation coordination, and delivery of commercial and industrial container cargo."
        },
        {
            "name": "container logistics pune",
            "description": "Container logistics pune involves coordinating container movement between business facilities, warehouses, industrial units, distribution centers, and destination locations. SSK Logistic provides practical transportation support designed around container availability, route requirements, cargo volume, and scheduling."
        },
        {
            "name": "container logistics company pune",
            "description": "As a container logistics company pune, SSK Logistic assists businesses with organized transportation of containerized goods across local and interstate routes. The service can support industrial freight, commercial consignments, warehouse transfers, and recurring container movement requirements."
        },
        {
            "name": "container truck transport pune",
            "description": "Container truck transport pune is suitable for businesses requiring road transportation of containerized cargo between different locations. SSK Logistic coordinates suitable container truck movement based on shipment size, route, loading point, destination, and required delivery schedule."
        },
        {
            "name": "container cargo transportation pune",
            "description": "Container cargo transportation pune supports businesses moving commercial products, industrial materials, inventory, and other goods in containerized loads. SSK Logistic provides structured transportation coordination for local distribution as well as long-distance interstate cargo movement."
        },
        {
            "name": "closed container transportation pune",
            "description": "Closed container transportation pune is useful when businesses require enclosed transportation for commercial and industrial goods. SSK Logistic supports closed container movement with planned vehicle coordination, route management, pickup scheduling, and destination delivery."
        },
        {
            "name": "closed body container transport pune",
            "description": "Closed body container transport pune provides businesses with enclosed road transportation for goods requiring protection from external exposure during transit. SSK Logistic coordinates transportation for commercial and industrial consignments according to cargo characteristics, route distance, and delivery requirements."
        },
        {
            "name": "freight container transport pune",
            "description": "Freight container transport pune supports businesses moving larger consignments through containerized road freight. SSK Logistic coordinates transportation between warehouses, industrial facilities, suppliers, distribution points, and destination markets based on freight volume and route requirements."
        },
        {
            "name": "industrial container transport pune",
            "description": "Industrial container transport pune is designed for businesses moving raw materials, production supplies, components, equipment, and finished industrial goods. SSK Logistic provides planned container transportation between manufacturing units, suppliers, warehouses, project locations, and destination markets."
        },
        {
            "name": "commercial container transport pune",
            "description": "Commercial container transport pune helps retailers, distributors, wholesalers, suppliers, and other businesses move larger quantities of products through organized container transportation. SSK Logistic coordinates commercial container movement according to shipment volume, route, and delivery schedule."
        },
        {
            "name": "container goods transport pune",
            "description": "Container goods transport pune supports businesses that need products and materials moved in enclosed or containerized loads. SSK Logistic assists with road transportation between business premises, warehouses, distribution centers, suppliers, and destination markets."
        },
        {
            "name": "container truck service pune",
            "description": "Container truck service pune provides businesses with road-based transportation for containerized cargo requiring suitable truck capacity. SSK Logistic coordinates truck movement according to container requirements, pickup location, destination, route distance, and shipment schedule."
        },
        {
            "name": "container transportation provider pune",
            "description": "A container transportation provider pune can help businesses manage recurring and project-based container movement requirements. SSK Logistic supports container transportation for industrial, commercial, warehouse, distribution, and interstate freight operations."
        },
        {
            "name": "reliable container transport pune",
            "description": "Reliable container transport pune is important for businesses managing scheduled movement of commercial and industrial cargo. SSK Logistic focuses on structured transportation planning, suitable vehicle coordination, route management, and organized pickup and delivery arrangements."
        },
        {
            "name": "secure container transportation pune",
            "description": "Secure container transportation pune supports businesses that require organized movement of cargo in enclosed or containerized loads. SSK Logistic coordinates transportation with attention to container suitability, loading requirements, planned routes, and destination delivery schedules."
        },
        {
            "name": "container freight services pune",
            "description": "Container freight services pune assist businesses with moving larger commercial and industrial consignments through containerized road transportation. SSK Logistic coordinates freight movement between suppliers, warehouses, factories, distribution centers, and final destinations."
        },
        {
            "name": "container logistics services pune",
            "description": "Container logistics services pune combine transportation and movement coordination for businesses managing containerized cargo across multiple locations. SSK Logistic supports pickup planning, road transportation, warehouse transfers, distribution movement, and destination delivery."
        },
        {
            "name": "container cargo transport company pune",
            "description": "A container cargo transport company pune can support businesses requiring planned transportation for containerized commercial and industrial consignments. SSK Logistic provides road cargo movement based on container type, shipment volume, origin, destination, route, and scheduling requirements."
        },
        {
            "name": "full truck load container transport pune",
            "description": "Full truck load container transport pune is suitable for businesses requiring dedicated truck capacity for a larger containerized shipment. SSK Logistic coordinates FTL container movement with direct route planning, suitable vehicle arrangements, pickup coordination, and destination delivery."
        },
        {
            "name": "container transport service provider pune",
            "description": "Businesses requiring a container transport service provider pune can use SSK Logistic for local, regional, and interstate container movement. Transportation support can be aligned with recurring shipments, warehouse transfers, industrial dispatches, commercial distribution, and full-load requirements."
        },
        {
            "name": "container transportation company near pune",
            "description": "Businesses searching for a container transportation company near pune can use SSK Logistic for containerized goods movement connected with Pune and surrounding commercial and industrial areas. Services support local pickups, regional distribution, warehouse transfers, and interstate transportation."
        },
        {
            "name": "professional container transport pune",
            "description": "Professional container transport pune requires coordination of cargo specifications, container requirements, loading locations, vehicle arrangements, routes, and delivery points. SSK Logistic provides structured transportation support for commercial and industrial containerized freight."
        }
    ],

    "tableData": [
        ["container transportation company pune", "container transport company pune"],
        ["container transportation services pune", "container transport services pune"],
        ["container logistics pune", "container logistics company pune"],
        ["container truck transport pune", "container cargo transportation pune"],
        ["closed container transportation pune", "closed body container transport pune"],
        ["freight container transport pune", "industrial container transport pune"],
        ["commercial container transport pune", "container goods transport pune"],
        ["container truck service pune", "container transportation provider pune"],
        ["reliable container transport pune", "secure container transportation pune"],
        ["container freight services pune", "container logistics services pune"],
        ["container cargo transport company pune", "full truck load container transport pune"],
        ["container transport service provider pune", "container transportation company near pune"],
        ["professional container transport pune", "Container Transportation Company in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Dedicated Container Transportation",
            WhyChoosedescription: "SSK Logistic supports businesses that require dedicated road transportation for containerized commercial and industrial cargo. Transportation planning is coordinated around container requirements, shipment volume, origin, destination, route distance, and delivery schedules."
        },
        {
            WhyChooseheading: "Enclosed Cargo Movement",
            WhyChoosedescription: "Closed and enclosed container transportation can be useful for businesses requiring organized movement of goods with reduced exposure during road transit. SSK Logistic coordinates suitable container transportation according to the nature of the cargo and route."
        },
        {
            WhyChooseheading: "Industrial Freight Coordination",
            WhyChoosedescription: "Industrial operations often need containers for moving raw materials, components, equipment, production goods, and finished products. SSK Logistic supports these requirements with transportation coordination between factories, suppliers, warehouses, and destination facilities."
        },
        {
            WhyChooseheading: "Commercial Distribution Support",
            WhyChoosedescription: "Commercial businesses may need regular container movement between warehouses, distribution centers, suppliers, and markets. SSK Logistic provides organized transportation support for recurring commercial container dispatches and destination-based freight requirements."
        },
        {
            WhyChooseheading: "Full Load Container Capability",
            WhyChoosedescription: "Larger containerized consignments may require dedicated vehicle capacity and direct transportation planning. SSK Logistic assists businesses with full truck load container movement, including pickup coordination, route planning, and destination delivery arrangements."
        },
        {
            WhyChooseheading: "Local and Interstate Connectivity",
            WhyChoosedescription: "Container transportation requirements often extend beyond Pune into Maharashtra and other parts of India. SSK Logistic supports regional and interstate road movement for businesses connecting their suppliers, warehouses, production units, and destination markets."
        },
        {
            WhyChooseheading: "Structured Pickup and Delivery",
            WhyChoosedescription: "Containerized freight can involve multiple pickup and delivery points across a business network. SSK Logistic coordinates transportation schedules around factories, warehouses, distribution centers, commercial facilities, and other designated cargo locations."
        },
        {
            WhyChooseheading: "Flexible Logistics Planning",
            WhyChoosedescription: "Every container shipment can have different cargo characteristics, route requirements, delivery timelines, and vehicle needs. SSK Logistic provides flexible transportation coordination that can be adapted to recurring shipments, project cargo, commercial distribution, and industrial freight movement."
        }
    ]

};









const faqData = [
    {
        question: "What container transportation services does SSK Logistic provide in Pune?",
        answer: "SSK Logistic supports businesses with container transportation from Pune for suitable commercial and industrial cargo, with vehicle arrangements planned according to container requirements, cargo details, route, loading conditions, and delivery schedule."
    },
    {
        question: "Can SSK Logistic arrange container transportation from Pune to other cities?",
        answer: "Container movement can be coordinated from Pune to destinations such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other locations across India."
    },
    {
        question: "What types of cargo can be transported using containers?",
        answer: "Suitable containerized shipments may include commercial goods, industrial materials, machinery, equipment, packaged products, raw materials, finished goods, supplies, and other cargo compatible with the required container and transportation arrangement."
    },
    {
        question: "Can SSK Logistic handle regular container transportation for businesses?",
        answer: "Companies with recurring container movement requirements can discuss transportation arrangements based on their regular routes, shipment frequency, cargo volume, loading requirements, vehicle capacity, and delivery schedules."
    },
    {
        question: "How does SSK Logistic plan container transportation?",
        answer: "Transportation planning considers the container specifications, cargo weight and dimensions, loading conditions, pickup location, destination, route distance, vehicle requirement, and expected delivery timeframe."
    },
    {
        question: "Can SSK Logistic provide container transportation from Pune to Mumbai?",
        answer: "Yes, container transportation between Pune and Mumbai can be arranged for suitable commercial and industrial shipments, including business stock, equipment, machinery, packaged goods, and other appropriate cargo."
    },
    {
        question: "Does SSK Logistic provide interstate container transportation from Pune?",
        answer: "Interstate container movement can be coordinated toward destinations in Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other regions based on the shipment and transportation requirements."
    },
    {
        question: "Can industrial companies use SSK Logistic for containerized cargo?",
        answer: "Manufacturers, suppliers, distributors, warehouses, and industrial businesses can utilize container transportation for suitable raw materials, finished goods, machinery, equipment, inventory, and other commercial consignments."
    },
    {
        question: "Can container transportation be customized according to cargo requirements?",
        answer: "Yes, transportation arrangements can be planned around container size, cargo quantity, weight, loading requirements, pickup location, destination, vehicle capacity, route, and preferred delivery schedule."
    },
    {
        question: "What details are required to arrange container transportation with SSK Logistic?",
        answer: "Businesses can provide the pickup location, destination, container requirement, cargo type, approximate weight and dimensions, loading details, preferred vehicle arrangement, and expected delivery timeframe to discuss a suitable transportation solution."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Dinesh Patwardhan",
        feedback: "We required container transportation from Pune to Chennai for an industrial shipment. SSK Logistic reviewed the cargo details and coordinated the transportation requirements according to our planned movement.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Vaishnavi More",
        feedback: "Our company needed a container arrangement for moving commercial materials from Pune to Mumbai. SSK Logistic was straightforward to coordinate with and handled the transportation planning according to our shipment details.",
        rating: 5
    }
];












    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Container Transportation Company in Pune",
  "image": "https://ssklogistics.in/assets/images/container-transportation-company-in-pune.webp",
  "description": "SSK Logistics provides Container Transportation Company in Pune services for businesses requiring organized and dependable movement of containerized cargo across Pune, Maharashtra and interstate destinations. Container transportation company Pune requirements can include the movement of commercial shipments, industrial materials, export-import cargo, machinery, equipment and other goods packed or transported in standard containers. Container transport company Pune services can be coordinated according to container size, cargo weight, pickup location, destination and required delivery schedule. Container transportation services Pune are suitable for manufacturers, exporters, importers, distributors, warehouses, logistics operators and commercial businesses that need reliable road transportation for containerized consignments. Container transport services Pune can support movement between factories, warehouses, distribution centers, industrial locations, ports and customer destinations. SSK Logistics can coordinate suitable transportation arrangements for full container loads and business cargo requiring dedicated vehicle movement. Container transportation requirements may also involve route planning, vehicle coordination, loading and unloading coordination and communication regarding pickup and delivery schedules. Businesses looking for container transport solutions in Pune can use such services for regular supply chain movements as well as project-based shipments. SSK Logistics focuses on practical container transportation coordination based on cargo specifications, vehicle requirements and destination routes, supporting businesses with flexible movement solutions for local, regional and interstate logistics needs.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Transport Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/container-transportation-company-in-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Container Transportation Company in Pune | Reliable Container Transport Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics offers container transportation services in Pune for industrial, commercial and containerized cargo with coordinated road transport solutions across local and interstate routes."
  />

  <meta
    name="keywords"
    content="Container Transportation Company in Pune, container transportation company Pune, container transport company Pune, container transportation services Pune, container transport services Pune, container transport company in Pune, container transportation company in Pune, container logistics Pune, container logistics services Pune, container cargo transport Pune, container cargo transportation Pune, container truck transport Pune, container road transportation Pune, container vehicle transport Pune, container freight transport Pune, container freight transportation Pune, full container load transport Pune, FCL container transport Pune, container goods transportation Pune, commercial container transport Pune, industrial container transportation Pune, container shipment transportation Pune, container delivery services Pune, container carrier Pune, container transporter Pune, container transportation services in Pune, container transport services in Pune, container logistics company Pune, container cargo transportation services Pune, interstate container transportation Pune, Maharashtra container transport Pune, warehouse container transport Pune, factory container transport Pune, port container transportation Pune, export container transport Pune, import container transport Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Containertransporttaioncompany;